import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Impressum.css';

const Impressum = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleBackToMap = () => {
    navigate('/');
  };

  // Mobile menu handlers
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleProtagonistinnen = () => {
    navigate('/');
    closeMobileMenu();
  };

  const handleEreignisse = () => {
    navigate('/ereignisse');
    closeMobileMenu();
  };

  return (
    <div className="impressum-page">
      {/* Header */}
      <div className="header">
        {/* Mobile burger menu button */}
        <button
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Menu"
        >
          <div className={`burger-line ${isMobileMenuOpen ? 'active' : ''}`}></div>
          <div className={`burger-line ${isMobileMenuOpen ? 'active' : ''}`}></div>
          <div className={`burger-line ${isMobileMenuOpen ? 'active' : ''}`}></div>
        </button>

        <div className="title-section">
        </div>

        {/* Desktop header buttons */}
        <div className="header-buttons desktop-only">
          <button onClick={() => navigate('/')} className="btn">
            Protagonistinnen
          </button>
          <button onClick={() => navigate('/ereignisse')} className="btn">
            Ereignisse
          </button>
        </div>
      </div>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`} onClick={closeMobileMenu}>
          <div className={`mobile-menu-content ${isMobileMenuOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
            <button
              className="mobile-menu-close"
              onClick={closeMobileMenu}
              aria-label="Close Menu"
            >
              <div className="burger-line active"></div>
              <div className="burger-line active"></div>
              <div className="burger-line active"></div>
            </button>
            <button
              onClick={() => { handleProtagonistinnen(); closeMobileMenu(); }}
              className="mobile-menu-item protagonistinnen-btn"
            >
              Protagonistinnen
            </button>
            <button
              onClick={() => { handleEreignisse(); closeMobileMenu(); }}
              className="mobile-menu-item ereignisse-btn"
            >
              Ereignisse
            </button>
          </div>
        </div>
      )}

      {/* Impressum Content */}
      <div className="impressum-content">
        <h1 className="impressum-title">Impressum</h1>

        <div className="impressum-section">
          <h2 className="section-title-impressum">— Inhalt</h2>
          <div className="section-content-impressum">
            <p>Zürcher Hochschule der Künste</p>
            <p>Fachrichtung Cast / Audiovisual Media</p>
            <p>Toni-Areal, Pfingstweidstrasse 96</p>
            <p>Postfach, CH-8031 Zürich</p>
          </div>
        </div>

        <div className="impressum-section">
          <h2 className="section-title-impressum">— Gestaltung</h2>
          <div className="section-content-impressum">
            <p>Kimberly Wyss, Marina Guscetti</p>
          </div>
        </div>

        <div className="impressum-section">
          <h2 className="section-title-impressum">— Entwicklung</h2>
          <div className="section-content-impressum">
            <p>Kimberly Wyss</p>
          </div>
        </div>

        <div className="impressum-section">
          <h2 className="section-title-impressum">— Nutzungsbedingungen</h2>
          <div className="section-content-impressum">
            <p>Es gelten die allgemeinen Nutzungsbedingungen der ZHdK.</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <span className="footer-left">Impressum</span>
        <span
          className="footer-right"
          onClick={() => window.open('https://alexaweiss.ch', '_blank')}
        >
          Ein Projekt von Alexa Weiss
        </span>
      </div>
    </div>
  );
};

export default Impressum;